<div *ngIf="!isLogin" class="page-container">
	<div class="not-found-content">
		<div style="width: 100%; height: 100%; overflow: hidden;">
			<ng-container [ngTemplateOutlet]="notFoundTemplate"></ng-container>
		</div>
	</div>
</div>
<lib-fo-toolbar-sidebar *ngIf="isLogin" #toolbarSidebar [isSidebarOnToolbar]="true" [isShowMenuButton]="true"
	[isDisableLogBook]="true">
	<div appContent class="page-container" [ngClass]="{'user-profile': !toolbarSidebar.isToolbarClosed()}">
		<div class="not-found-content" *ngIf="toolbarSidebar.isToolbarClosed()">
			<div style="width: 100%; height: 100%; overflow: hidden;">
				<ng-container [ngTemplateOutlet]="notFoundTemplate"></ng-container>
			</div>
		</div>
		<lib-user-profile class="user-profile-container" (closeProfile)="toolbarSidebar.resetToolbar()"
			[userProfile]="toolbarSidebar.getReqUserProfile()" [userAuthen]="toolbarSidebar.getReqUserAuthen()"
			*ngIf="!toolbarSidebar.isToolbarClosed()">
		</lib-user-profile>
	</div>
</lib-fo-toolbar-sidebar>

<ng-template #notFoundTemplate>
	<div appContent id="notfound">
		<div class="notfound">
			<div class="notfound-404">
				<h1>4<span>0</span>4</h1>
			</div>
			<h2>the page you requested could not found</h2>
		</div>
	</div>
</ng-template>